import { ValueOf } from 'type-fest';

export const AMOUNT_DISPLAY_TYPE = {
  NORMAL: 'normal',
  UNSETTLED: 'unsettled',
  HIDE: 'hide',
} as const;

export const UNIT_MAPPER = {
  [AMOUNT_DISPLAY_TYPE.NORMAL]: '円',
  [AMOUNT_DISPLAY_TYPE.UNSETTLED]: '円',
  [AMOUNT_DISPLAY_TYPE.HIDE]: '',
} as const;

export type AmountDisplayType = ValueOf<typeof AMOUNT_DISPLAY_TYPE>;
